import { sendSlackMessage } from "./";
import { getCacheWithoutExpiry } from "../";

type UserData = {
  id?: string | null;
  name?: string | null;
  email?: string | null;
  currentTeam?: string | null;
} | null;

export const sendSlackLogin = async (
  userData: UserData = null,
): Promise<null> => {
  if (import.meta.env.VITE_NODE_ENV === "production") {
    // If userData is not provided, try to get it from cache
    let user = userData;
    if (!user) {
      try {
        user = (await getCacheWithoutExpiry("me")) as UserData;
      } catch {
        // If cache fails, user will remain null
      }
    }

    const userId = user?.id || "N/A";
    const userName = user?.name || "N/A";
    const userEmail = user?.email || "N/A";
    const teamName = user?.currentTeam || "NA";

    const slackErrorData = {
      channel: "login",
      type: "success",
      heading: `Login activity: After login, user landed on ${window.location.href}`,
      detail: `${userName} (${userEmail}) has logged in on the ${import.meta.env.VITE_NODE_ENV} environment`,
      fields: [
        {
          title: "User ID",
          value: userId,
        },
        {
          title: "User Name",
          value: userName,
        },
        {
          title: "User Email",
          value: userEmail,
        },
        {
          title: "User Team",
          value: teamName,
        },
      ],
    };
    sendSlackMessage(slackErrorData).then();
  }
  return null;
};
